import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/2022/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'ロマンシング佐賀 2022｜SQUARE ENIX',
      description: 'JR唐津線・筑肥線沿線を走る全16車両のオリジナルラッピング列車を中心に、各所で佐賀と“サガ”が融合したイベントを開催。あなただけのフリーシナリオの冒険をお楽しみください。'
    }
  },
  {
    path: '/2022/train',
    name: 'train',
    component: () => import(/* webpackChunkName: "train" */ '../views/TrainView.vue'),
    meta: {
      title: 'ロマ佐賀列車｜ロマンシング佐賀 2022｜SQUARE ENIX',
      description: 'JR唐津線・筑肥線沿線を走る全16車両のオリジナルラッピング列車を中心に、オリジナル駅名標や駅メロディまで、沿線を中心とした大型コラボレーション。'
    }
  },
  {
    path: '/2022/rally',
    name: 'rally',
    component: () => import(/* webpackChunkName: "rally" */ '../views/RallyView.vue'),
    meta: {
      title: '冒険ラリー｜ロマンシング佐賀 2022｜SQUARE ENIX',
      description: null
    }
  },
  {
    path: '/2022/spot',
    name: 'spot',
    component: () => import(/* webpackChunkName: "spot" */ '../views/SpotView.vue'),
    meta: {
      title: 'ロマ佐賀スポット｜ロマンシング佐賀 2022｜SQUARE ENIX',
      description: null
    }
  },
  {
    path: '/2022/event',
    name: 'event',
    component: () => import(/* webpackChunkName: "event" */ '../views/EventView.vue'),
    meta: {
      title: 'イベント｜ロマンシング佐賀 2022｜SQUARE ENIX',
      description: 'JR唐津駅の改札を出てすぐの好立地に、ロマ佐賀列車をテーマにしたイベントスペースが期間限定でオープン。'
    }
  },
  {
    path: '/2022/goods',
    name: 'goods',
    component: () => import(/* webpackChunkName: "goods" */ '../views/GoodsView.vue'),
    meta: {
      title: '連携グッズ｜ロマンシング佐賀 2022｜SQUARE ENIX',
      description: null
    }
  },
  {
    path: '/2022/story',
    name: 'story',
    component: () => import(/* webpackChunkName: "story" */ '../views/StoryView.vue'),
    meta: {
      title: 'ストーリー｜ロマンシング佐賀 2022｜SQUARE ENIX',
      description: '地方自治体とゲーム、奇跡の連携はどこまでも続いていく。佐賀県とスクウェア・エニックス、それぞれの代表ごあいさつ。そして、これまでのロマンシング佐賀の歩みを振り返ります。'
    }
  },
  {
    path: '/2022/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "news" */ '../views/NewsView.vue'),
    meta: {
      title: 'ニュース｜ロマンシング佐賀 2022｜SQUARE ENIX',
      description: '『ロマンシング佐賀2022』に関する各種ニュースをお知らせします。'
    }
  },
  {
    path: '/2022/news/:id',
    name: 'post',
    component: () => import(/* webpackChunkName: "post" */ '../views/PostView.vue'),
    meta: {
      description: null
    },
  },
  {
    path: '/sagafuro',
    name: 'sagafuro',
    component: () => import(/* webpackChunkName: "sagafuro" */ '../views/SagafuroView.vue'),
    meta: {
      title: 'SaGa風呂｜SQUARE ENIX',
      description: '佐賀が誇る温泉地で“SaGa風呂”コラボレーション！「サガ」シリーズのキャラクターがデザインされたマンホールや有田焼陶板のモニュメントが旅人をお迎えします。',
      icon: `/sagafuro/favicon.ico`,
      image: `/sagafuro/ogp.jpg`,
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
